var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.toolCategoryList),function(toolCategory){return _c('div',{key:toolCategory,staticClass:"tool-category",class:{ selected: toolCategory === _vm.comparisonToolCategory },on:{"click":function($event){return _vm.selectToolCategory(toolCategory)}}},[_c('span',[_vm._v("\n      "+_vm._s(toolCategory === 'All'
          ? _vm.$t('comparisonFeature.tools.categoryAll')
          : toolCategory === 'Routing tools'
          ? _vm.$t('comparisonFeature.tools.categoryRoutingTools')
          : toolCategory === 'Database'
          ? _vm.$t('comparisonFeature.tools.categoryDatabase')
          : toolCategory === 'Activity'
          ? _vm.$t('comparisonFeature.tools.categoryActivity')
          : '')+"\n    ")]),_c('span',[_c('fa',{staticClass:"icon",attrs:{"icon":"chevron-right"}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }